var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cms-divider-block"},[(_vm.block.title)?_c('div',{staticClass:"cms-divider-labeled"},[_c('span',{staticClass:"cms-divider-line"}),_c('span',{staticClass:"cms-divider-title"},[_vm._v(_vm._s(_vm.block.title))]),_c('span',{staticClass:"cms-divider-line"})]):_c('hr',{staticClass:"cms-divider-line-only"})])
}
var staticRenderFns = []

export { render, staticRenderFns }